<template>
  <v-dialog max-width="1000px" v-model="dialog">
    <v-card>
      <v-card-title class="headline">
        <v-btn @click="toPrint()">
          <v-icon>print</v-icon>
        </v-btn>Reporte de venta
      </v-card-title>

      <v-card-text>
        <div id="factura">
          <section>
            <div>
              <h3 class="text-center">{{ tipo }}</h3>
              <p class="text-center">Impreso: {{date}}</p>
            </div>
          </section>
          <br />
          <section>
            <div>
              <table id="facarticulo" style="width:100%">
                <thead  style="background: #2183e3 !important; color:white; padding-top: 5px !important; padding-bottom:5px !important">
                  <tr id="fa" class="text-center">
                    <th>#</th>
                    <th>ARTICULO</th>
                    <th>CANTIDAD</th>
                    <th>UNIDAD</th>
                  </tr>
                </thead>
                <tbody v-if="tipo=='Almacen'">
                  <tr v-for="(item, index) of ventas" :key="item.id" class="text-center">
                    <td class="text-center">{{ index + 1}}</td>
                    <td class="text-center">{{ item.articulo }}</td>
                    <td class="text-center">{{ item.cantidad }}</td>
                    <td class="text-center">{{ item.unidad }}</td>
                  </tr>
                </tbody>
                <tbody v-if="tipo=='Distribucion'">
                  <tr v-for="(item, index) of distribucion" :key="item.id" class="text-center">
                    <td class="text-center">{{ index + 1}}</td>
                    <td class="text-center">{{ item.articulo }}</td>
                    <td class="text-center">{{ item.cantidad }}</td>
                    <td class="text-center">{{ item.unidad }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  
                </tfoot>
              </table>
              
            </div>
          </section>
          <br />
          <br />
          <footer>
            <div id="gracias">
              <p>
                <b>Fin de la lista!</b>
              </p>
            </div>
          </footer>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="ocultarComprobante()" color="blue darken-1" text>Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import html2canvas from "html2canvas";
import moment from 'moment';

export default {
  data() {
    return {
      dialog: false,
      tipo:null,
      date:moment(new Date()).format('LL')
    };
  },
  props:['distribucion','ventas'],
  created(){
    moment.locale("es")
  },
  methods: {
    ...mapActions('clienteNamespace',['getCliente']),
    ocultarComprobante() {
      this.dialog = false;
    },
    calcularTotal(){},
    ordenarLista: function ( order ) {
      if(this.ventas.length > 0) {
        this.ventas.sort( (a, b) => {
          if( order == 'Unidad' ){
            if( a.unidad > b.unidad ) { return 1 }
            if( a.unidad < b.unidad ) { return -1 }
          }else{
            if( a.articulo > b.articulo ) { return 1 }
            if( a.articulo < b.articulo ) { return -1 }
          }
          return 0;
          
        });
        
      }
      if(this.distribucion.length > 0)
        this.distribucion.sort( (a, b) => {
          if( order == 'Unidad' ){
            if( a.unidad > b.unidad ) { return 1 }
            if( a.unidad < b.unidad ) { return -1 }
          }else{
            if( a.articulo > b.articulo ) { return 1 }
            if( a.articulo < b.articulo ) { return -1 }
          }
          return 0;
        });   
    },
    toPrint(){
      this.$htmlToPaper('factura')
    }
  },
};
</script>
<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#logo {
  float: left;
  margin-left: 2%;
  margin-right: 2%;
}
#imagen {
  width: 100px;
}

#fact {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 2%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
}

#facarticulo thead {
  padding: 20px;
  background: #2183e3;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
</style>